// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDeductiblesByServiceTypePropertyDto
 */
export interface IDeductiblesByServiceTypePropertyDto {
    /**
     * 
     * @type {string}
     * @memberof IDeductiblesByServiceTypePropertyDto
     */
    deductibles_by_service_type?: IDeductiblesByServiceTypePropertyDtoDeductiblesByServiceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IDeductiblesByServiceTypePropertyDto
     */
    deductibles_by_service_type_state?: IDeductiblesByServiceTypePropertyDtoDeductiblesByServiceTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IDeductiblesByServiceTypePropertyDtoDeductiblesByServiceTypeEnum {
    CARD = 'CARD',
    MANUAL_CLAIM = 'MANUAL_CLAIM',
    HEALTH_PLAN = 'HEALTH_PLAN',
    HIDDEN = 'HIDDEN'
}
/**
* @export
* @enum {string}
*/
export enum IDeductiblesByServiceTypePropertyDtoDeductiblesByServiceTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IDeductiblesByServiceTypePropertyDto interface.
 */
export function instanceOfIDeductiblesByServiceTypePropertyDto(value: object): value is IDeductiblesByServiceTypePropertyDto {
    return true;
}

export function IDeductiblesByServiceTypePropertyDtoFromJSON(json: any): IDeductiblesByServiceTypePropertyDto {
    return IDeductiblesByServiceTypePropertyDtoFromJSONTyped(json, false);
}

export function IDeductiblesByServiceTypePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDeductiblesByServiceTypePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'deductibles_by_service_type': json['deductibles_by_service_type'] == null ? undefined : json['deductibles_by_service_type'],
        'deductibles_by_service_type_state': json['deductibles_by_service_type_state'] == null ? undefined : json['deductibles_by_service_type_state'],
    };
}

export function IDeductiblesByServiceTypePropertyDtoToJSON(json: any): IDeductiblesByServiceTypePropertyDto {
    return IDeductiblesByServiceTypePropertyDtoToJSONTyped(json, false);
}

export function IDeductiblesByServiceTypePropertyDtoToJSONTyped(value?: IDeductiblesByServiceTypePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deductibles_by_service_type': value['deductibles_by_service_type'],
        'deductibles_by_service_type_state': value['deductibles_by_service_type_state'],
    };
}

